import { useState, useEffect, useCallback } from 'react';

let pendingSlug: string | undefined = undefined;

export function getPendingSlug(): string | undefined {
  return pendingSlug;
}

export function useConsultationModal() {
  const [isOpen, setIsOpen] = useState(
    () => typeof window !== 'undefined' && window.location.hash === '#consultation',
  );
  const [shopSlug, setShopSlug] = useState(null)

  useEffect(() => {
    const handler = () => {
      const open = window.location.hash === '#consultation';
      setIsOpen(open);
      if (!open) {
        pendingSlug = undefined;
      }
    };
    window.addEventListener('hashchange', handler);
    return () => window.removeEventListener('hashchange', handler);
  }, []);

  const open = useCallback((slug?: string) => {
    // pendingSlug = slug;
    setShopSlug(slug)
    window.location.hash = 'consultation';
  }, []);

  const close = useCallback(() => {
    if (window.location.hash === '#consultation') {
      window.history.back();
    }
  }, []);

  return { isOpen, open, close, shopSlug };
}